import { CollectionStore } from './collection.store';
import { CollectionSummaryStore } from './collection.summary.store';
import { FormStore } from './form.store';
import { FormSummaryStore } from './form.summary.store';
import { TagStore } from './tag.store';
import { TagSummaryStore } from './tag.summary.store';
import { UserProfileStore } from './user.profile.store';

export const AppStore = {
	Collection: new CollectionStore(),
	CollectionSummary: new CollectionSummaryStore(),
	Form: new FormStore(),
	FormSummary: new FormSummaryStore(),
	Tag: new TagStore(),
	TagSummary: new TagSummaryStore(),
	UserProfile: new UserProfileStore(),
};
